import { Component, Input, OnInit } from '@angular/core';
import { IdentityService } from 'projects/bis-shared/src/lib/auth/identity.service';
import {
  Level1ReviewerRoles,
  Level2ReviewerRoles,
  WorkloadAdminRoles,
} from 'projects/bis-shared/src/lib/utility/roles';
import * as _ from 'lodash';

@Component({
  selector: 'app-priorauth-queue-component',
  templateUrl: './prior-auth-queue.component.html',
  styleUrls: ['./prior-auth-queue.component.scss'],
})
export class PriorAuthQueueComponent implements OnInit {
  @Input() isInsurerUser: boolean;
  isWorkloadAdminUser: boolean = false;
  isLevelReviewerUser: boolean = false;

  constructor(private identityService: IdentityService) {}

  ngOnInit(): void {
    this.isWorkloadAdminUser = this.identityService.hasAnyRoles(WorkloadAdminRoles);
    this.isLevelReviewerUser = this.identityService.hasAnyRoles(
      _.union(Level1ReviewerRoles, Level2ReviewerRoles),
    );
  }
}
